import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-circle',
    templateUrl: './circle.component.html',
    styleUrls: ['./circle.component.scss'],
    standalone: false
})
export class CircleComponent implements OnInit
{
    @Input() cx: number;
    @Input() cy: number;
    @Input() begin: string;

    constructor() { }

    ngOnInit ()
    {
    }

}
